export const PARTITION_FUNCTION_CONSTANT = 'partitionBy';
export const MAP_COLUMN_CONSTANT = 'mapColumn';
export const dataFlowPatternParameter = '$$';
export const dataFlowHierarchyPathParameter = '$0';
export const dataFlowPositionParameter = '$#';
export const dataFlowPatternNameParameter = 'name';
export const dataFlowPatternTypeParameter = 'type';
export const dataFlowPatternStreamParameter = 'stream';
export const dataFlowPatternOriginParameter = 'origin';
export const dataFlowPatternPositionParameter = 'position';

export const HIGHER_ORDER_FUNCTIONS: string[] = [
    'MAP',
    'MAPIF',
    'MAPINDEX',
    'MAPLOOP',
    'IMAP',
    'REDUCE',
    'FILTER',
    'FIND',
    'CONTAINS',
    'SORT',
    'REASSOCIATE',
    'MAPASSOCIATION'
];
